import React, { useState } from "react";
import { RightArrow, LeftArrow, Exit } from "./Icons";
import Field from "./Field";

const cardStyle = {
    width: 200,
    height: 300,
    objectFit: 'cover',
    objectPosition: 'center',
    borderRadius: 10,
    position: 'relative',
    boxShadow: '3px 3px 5px var(--black50)',
    transition: 'all 500ms ease 0s'
}
const buttonStyle = {
    width: 240,
    height: 340,
    padding: 25,
    backgroundColor: 'transparent',
    overflowY: 'clip'
}

const fullScreenViewStyle = {
    position: 'fixed',
    zIndex: 100,
    width: '100vw',
    height: '100vh',
    padding: '20px 10px',
    backgroundColor: 'var(--black50)',
    top: 0,
    left: 0,
    display: 'grid',
    placeItems: 'center',
    gridTemplateRows: '30px auto'
}

export default function ImgStack({ images, className, editable, setImages }) {

    const [fullScreenView, setFullScreenView] = useState(false);
    const [imageIndex, setImageIndex] = useState(0);

    const updateName = (imageName) => {
        // Create a new array with the updated object
        //console.log('name update:', imageName)
        const updatedImages = [...images];
        updatedImages[imageIndex].name = imageName;
        // Update the state with the new array
        setImages(updatedImages);
    }

    // the following lines of code define the card stack positions
    // without offsets the cards line from left to write next to each other
    // to create an overlay effect I have to offset each card more and more to return it
    // from its orignal positon to the one it has to be in
    const positionOffset = 200; // This value is equal to the width of the pictures
    // it offsets the images to make them look stacked
    const staticOffset = 7; // this value spreads the images a little bit to look stacked
    // othervise the images would exactly overlay each other and you would only see the one at the top
    const [hoverOffset, setHoverOffset] = useState(0); // this part of the images offset changes on hover
    const frontCardStyle = {
        ...cardStyle,
        top: -staticOffset - hoverOffset * 2, // on hover double hover offset up
        // static offset is up
        left: -staticOffset - hoverOffset, // on hover single hover offset left
        // static offset is left
        zIndex: 2 // overlaying over the other two images 

    }
    const midCardStyle = {
        ...cardStyle,
        top: -hoverOffset, // no static offset, single hover offset up
        zIndex: 1, // middle card between the two others
        left: images.length > 1 && (hoverOffset - positionOffset) // if there is more than one card then use the position and hover offsets
        // middle card has no default offset
    }

    const backCardStyle = {
        ...cardStyle,
        zIndex: 0, // lowest card in the background
        top: staticOffset, // static offset down, no top offset on hover
        left: staticOffset + hoverOffset * 2 - positionOffset * 2
        // static offset right , double hover offset to the right, positon offset double to the left
    }

    return (
        <React.Fragment>
            <button
                className={className}
                style={buttonStyle}
                onMouseEnter={() => { setHoverOffset(7) }}
                onMouseLeave={() => { setHoverOffset(0) }}
                onClick={() => { setFullScreenView(true) }}
                type='button'
            >
                {images.slice(0, 3).map((img, index) => (
                    <img src={img.src} alt={img.name} key={img.name}
                        style={
                            images.length > 1 ? (
                                index === 0 ? frontCardStyle :
                                    index === 1 ? midCardStyle :
                                        index === 2 && backCardStyle
                            ) : midCardStyle
                        }
                    />
                ))}
            </button>
            {fullScreenView && <div style={fullScreenViewStyle}>
                <button
                    type='button'
                    style={{ justifySelf: 'end' }}
                    className="whiteIconBtn"
                    onClick={() => { setFullScreenView(false) }}>
                    <Exit />
                </button>
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: '30px auto 30px',
                    placeItems: 'center',
                    gap: 10
                }}>
                    {/* Go left button */}
                    <button
                        className={imageIndex === 0 ? "whiteIconDisabled" : "whiteIconBtn"}
                        type='button'
                        style={{ gridColumn: '1', gridRow: '1' }}
                        onClick={() => {
                            //console.log('old index: ', imageIndex)
                            if (imageIndex !== 0) { setImageIndex(imageIndex - 1); }
                        }}>
                        <LeftArrow disabled={imageIndex === 0} />
                    </button>
                    {/* Image in the center */}
                    <img
                        src={images[imageIndex].src}
                        alt={images[imageIndex].name}
                        className='shadow'
                        style={{
                            maxWidth: 'calc(100vw - 120px)',
                            maxHeight: 'calc(100vh - 150px)',
                            gridColumn: '2'
                        }}
                    />
                    {/* Go right button */}
                    <button
                        type='button'
                        className={imageIndex === images.length - 1 ? "whiteIconDisabled" : "whiteIconBtn"}
                        style={{ gridColumn: '3', gridRow: '1' }}
                        onClick={() => {
                            //console.log('old index: ', imageIndex)
                            if (imageIndex !== images.length - 1) { setImageIndex(imageIndex + 1); }
                        }}>
                        <RightArrow disabled={imageIndex === images.length - 1} />
                    </button>
                    {/* Name on the bottom */}
                    {editable ?
                        <div className='imgTitle shadow'>
                            <Field
                                type='h4'
                                value={images[imageIndex].name}
                                color="white"
                                inForm
                                updateValue={updateName}
                            />
                        </div>
                        :
                        <h4 className='imgTitle shadow'>{images[imageIndex].name}</h4>
                    }
                </div>
            </div>}
        </React.Fragment>

    );
}